<template>
  <el-card
    class="background"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="deposit-audit">
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
        @changeMethod="changeMethod"
        :rules="formRules"
      ></SiruiSearch>
      <div class="result-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          :loading="loading"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="() => getDetailtMgtList()"
          @handleCurrentChange="() => getDetailtMgtList()"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="tableColumns"
          :spanMethod="mergeRowMethod"
          :cellClick="cellClick"
          :cellStyle="cellStyle"
          show-footer
          :footer-method="footerMethod"
        >
          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <span v-if="item.field == 'contractType'">
                {{ getColumnName('contractType', scope.row[item.field]) }}</span
              >
              <span v-else-if="item.field == 'leaseDuration'">
                {{ getLeaseDuration(scope.row) }}</span
              >
              <span v-else-if="item.field == 'contractStatus'">
                {{ getColumnName('contractStatus', scope.row[item.field]) }}</span
              >
              <span v-else>{{ scope.row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
    </div>
  </el-card>
</template>

<script>
  import DEPOSITAPI from '@/api/reportManagement';
  // import API from '@/api/property/meterManagement';
  import { searchColumns, defaultTableColumns } from './columns';
  import ReportMixin from './mixins/reportMixin';
  import moment from 'moment';
  export default {
    name: 'DepositOverview',
    mixins: [ReportMixin],
    mounted() {
      this.queryData.contractCompanyNo = this.userInfo.companyCode;
      this.department(this.userInfo.companyCode);
      this.queryData.contractDepartmentNo = this.userInfo.departmentCode;
      this.queryData.companyName = this.userInfo.companyName;
      this.queryData.departmentName = this.userInfo.departmentName;
      this.queryData.paymentDays = [
        moment(new Date()).format('yyyy-MM'),
        moment(new Date()).format('yyyy-MM'),
      ];
      this.$refs.siruiTable.setPageSize(10);
      this.getDetailtMgtList();
      this.getButtonList();
      this.getCompany();
    },
    data() {
      return {
        loading: false,
        tableColumns: [],
        menuButtonList: [], // 表格功能按钮
        value: null,
        treeData: [],
        paymentDays: null,
        tableData: [],
        copyTableData: [],
        dateKey: Date.now(),
        queryData: {
          paymentDays: null,
          contractCompanyNo: null,
          contractDepartmentNo: null,
          companyName: null,
          departmentName: null,
          customerName: null,
          contractNo: null,
          expenseType: null,
          receivableAccountPeriod: null,
          receivableAccountPeriod2: null,
          finalNotReceived: null,
          judgeFlag: null,
        },
        formRules: {
          finalNotReceived: [{ required: true, message: '请输入', trigger: 'blur' }],
          judgeFlag: [{ required: true, message: '请选择', trigger: 'blur' }],
        },
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this);
      },
    },
    created() {
      let params = this.$route.params;
      if (params && params.expenseType) {
        this.queryData.expenseType = [params.expenseType];
      }
    },
    methods: {
      footerMethod({ columns, data }) {
        let returnAmountProps = [
          'beginPeriodNotReceived',
          'currentReceivables',
          'totalReceivables',
          'currentReceived',
          'totalReceived',
          'finalNotReceived',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return '合计';
            }
            if (returnAmountProps.includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
        ];
      },
      // 表格合并行
      mergeRowMethod({ rowIndex, columnIndex }) {
        switch (
          columnIndex // 将列索引作为判断值
        ) {
          case 0:
            return this.mergeCol('index', rowIndex, this.tableData);
          case 1:
            return this.mergeCol('index', rowIndex, this.tableData);
          case 2:
            return this.mergeCol('index', rowIndex, this.tableData);
          // case 3:
          //   return this.mergeCol('index', rowIndex, this.tableData);
          // case 4:
          //   return this.mergeCol('spaceAssetName', rowIndex, this.tableData);
        }
      },

      dataStructure(data) {
        if (data.children && data.children.length) {
          data.children.forEach((item) => {
            this.dataStructure(item);
          });
        } else {
          this.treeData.push(data.id);
        }
      },
      // 获取列表
      async getDetailtMgtList() {
        this.queryData.receivableAccountPeriod = this.queryData.paymentDays[0];
        this.queryData.receivableAccountPeriod2 = this.queryData.paymentDays[1];
        let params = { ...this.queryData };
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params = this.filterEmpty(params);
        this.loading = true;
        const { data } = await this.$axios.post(DEPOSITAPI.STORAGE_DETAIL_ACCOUNT_LIST, params);
        if (data && data.data && data.code == 0) {
          console.log('depositRes', data);
          this.tableData = data.data.records || [];
          this.copyTableData = JSON.parse(JSON.stringify(data.data.records));
          let list = this.tableStructure(data.data.records);
          this.tableData = list;
          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.$refs.siruiTable.setPageSize(data.data.size);
        } else {
          this.$message.error(data.msg);
        }
        // //清空选择fixme
        this.selectedItems = [];
        this.loading = false;
      },
      async resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.selectedItems = [];
        this.queryData.contractCompanyNo = this.userInfo.companyCode;
        await this.department(this.userInfo.companyCode);
        this.queryData.contractDepartmentNo = this.userInfo.departmentCode;
        this.queryData.paymentDays = [
          moment(new Date()).format('yyyy-MM'),
          moment(new Date()).format('yyyy-MM'),
        ];
        this.dateKey = Date.now();
        this.getDetailtMgtList();
      },
      handleSelectionChange(row) {
        this.selectedItems = row;
      },
      // 搜索
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        if (this.queryData.finalNotReceived || this.queryData.judgeFlag) {
          this.$refs.searchRef.validate((valid) => {
            if (valid) {
              this.getDetailtMgtList();
            }
          });
        } else {
          this.getDetailtMgtList();
        }
      },

      // 表格上面的按钮
      async chooseClick(type) {
        let empty = !this.selectedItems || !this.selectedItems.length;
        if (empty && type != 'export') {
          this.$message.error('请选择数据！');
          return;
        }
        switch (type) {
          case 'print':
            this.goPrint();
            break;
          case 'export':
            this.handleExport(this.selectedItems);
            break;
          default:
            break;
        }
      },
      async handleExport(items) {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = { ...this.queryData, pageNum, pageSize };
        const ids = [];
        if (items.length) {
          if (params.contractNo) {
            delete params.contractNo;
          }
          if (params.customerName) {
            delete params.customerName;
          }
          items.forEach((item) => {
            ids.push(item.contractNo);
          });
          params.contractNoList = ids;
        }
        let api = DEPOSITAPI.STORAGE_DETAIL_EXPORT;
        this.$axios.post(api, params).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      goPrint() {
        let arr = [];
        this.copyTableData.forEach((item) => {
          for (let i = 0; i < this.selectedItems.length; i++) {
            if (
              item.contractNo == this.selectedItems[i].contractNo &&
              item.customerName == this.selectedItems[i].customerName &&
              item.customerNo == this.selectedItems[i].customerNo
            ) {
              arr.push(item);
              break;
            }
          }
          console.log(item, '循环数据');
        });
        console.log(arr, '打印数据');
        let params = {
          companyName: this.userInfo.companyName,
          departmentName: this.userInfo.departmentName,
          list: arr,
        };
        let obj = {
          params: JSON.stringify(params),
        };
        const routeData = this.$router.resolve({
          name: `storagePrint`,
          query: obj,
        });
        window.open(routeData.href);
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns()).then(() => {
          this.tableColumns = defaultTableColumns();
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },

      cellStyle({ column }) {
        if (column.property == 'contractNo') {
          return {
            color: '#009fcc',
          };
        }
      },
      cellClick(val) {
        if (val.column?.property == 'contractNo') {
          this.handleContractDetail(val.row);
        }
      },
      handleContractDetail(row) {
        console.log(row, '跳转合同详情');
        const path = {
          path: 'propert/detailLeaseContract',
          name: 'detailLeaseContract',
          meta: {
            keepAlive: true,
            title: '租赁合同详情',
          },
          query: {
            type: 'detail',
            contractNo: row.contractNo,
          },
        };
        this.$router.push(path);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
